import _isNumber from "lodash/isNumber";
import _gte from "lodash/gte";
import _isUndefined from "lodash/isUndefined";
import _first from "lodash/first";
import { isTextElement } from "../utils/validate/index.js";
export const DEFAULT_SIBLING_COUNT = 3;
export const DEFAULT_OPTION_HEIGHT = 44;
const DEFAULT_COLUMN_INDEX = 0;
export function validPickerColumn(column) {
    const { index } = column;
    return _isNumber(index) && _gte(index, DEFAULT_COLUMN_INDEX) ? column : undefined;
}
export function getPickerOptionKey(option) {
    const { key, value, label, children } = option;
    const newKey = key ?? value ?? label;
    if (_isUndefined(newKey) && isTextElement(children)) {
        return children;
    }
    return newKey;
}
export function getPickerValue(values, multiColumns) {
    return multiColumns ? values : _first(values);
}
